import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientRehabImpMarketsData,PatientRehabImpMarkets } from '../../../interfaces/masters/patient-rehab-imp-markets';
import { PatientRehabImpMarketsApi } from '../api/patient-rehab-imp-markets.api';

@Injectable()
export class PatientRehabImpMarketsMstService extends PatientRehabImpMarketsData {

  constructor(private api: PatientRehabImpMarketsApi) { 
    super();   
  }
  list(url: string): Observable<PatientRehabImpMarkets[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PatientRehabImpMarkets>{
      return this.api.getById(url); 
  }

  create(url: string, data:PatientRehabImpMarkets): Observable<PatientRehabImpMarkets> {
    return this.api.add(url,data);
  }

  update(url: string, data:PatientRehabImpMarkets): Observable<PatientRehabImpMarkets> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  }
}
